import {Spinner, SpinnerStyle} from '@mintdata-wsp/common/components/spinner/Spinner';
import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {LoaderModel} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/loader/LoaderModel';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./Loader.less');
const cx = classnames.bind(styles);

export interface ILoaderProps
{
    loaderPropValue:LoaderModel
}

interface ILoaderState
{
}

@observer
export class Loader extends React.Component<ILoaderProps, ILoaderState>
{
    public componentWillMount():void
    {
        const {fonts: fontsController} = commonControllers.assets;
        const {loaderPropValue: loader} = this.props;

        fontsController.checkAndLoadFont(loader.caption.font);
    }

    public componentWillUnmount():void
    {
        const {fonts: fontsController} = commonControllers.assets;
        const {loaderPropValue: loader} = this.props;

        fontsController.unloadFont(loader.caption.font);
    }

    componentWillReceiveProps(nextProps:Readonly<ILoaderProps>, nextContext:any):void
    {
        const {fonts: fontsController} = commonControllers.assets;
        const {loaderPropValue: newLoader} = nextProps;
        const {loaderPropValue: loader} = this.props;

        fontsController.checkAndLoadFont(newLoader.caption.font, loader.caption.font);
    }

    public render():JSX.Element
    {
        const {loaderPropValue: loader} = this.props;

        const isLoading = loader.isLoading.value;

        if( !isLoading ) return null;

        const showSpinner = loader.showSpinner.value;
        const isTextVisible = loader.caption.isVisible.value;
        const text = loader.caption.text.toString();

        const showText = isTextVisible && text;

        if( !showSpinner && !showText ) return null;

        const spinnerSize = loader.spinnerSize.value.value;
        const font = loader.caption.font;
        const bg = loader.bg;

        return (
            <div
                className={cx('spinnerOverlay')}
                style={{background: bg.toCssString()}}
            >
                {
                    showSpinner &&
                    <span className={cx('spinner')}>
                        <Spinner size={spinnerSize} style={SpinnerStyle.Blue} />
                    </span>
                }
                {
                    showText &&
                    <span
                        className={cx('text', {showSpinner})}
                        style={{...font.toCSS()}}
                    >
                        {text}
                    </span>
                }
            </div>
        );
    }
}
